export default {
  groupBuy: {
  productSource: '商品来源',
  sourceShopId: '门店 ID',
  poiId: 'poiId',
  enterPoiId: '输入 poiId',
  productInfo: '商品信息',
  linkedProduct: '核销商品',
  linkStatus: '关联状态',
  linked: '已关联',
  notLinked: '未关联',
  pulledTime: '商品更新时间',
  platformProductSearch: '输入商品名称、商品ID或规格ID',
  pullProducts: '拉取平台商品',
  pullHistory: '拉取记录',
  platformProductId: '商品ID',
  platformSkuId: '规格 ID',
  platformProductSkuId: '商品 ID / 规格 ID',
  localProductUnavailable: '核销商品已不可用',
  linkProduct: '关联商品',
  editProductLink: '修改关联',
  unlinkProduct: '解除关联',
  applicableRange: '适用门店',
  applicabilityUnknown: '平台未提供完整适用门店范围',
  applicabilityHint: '以下为平台适用门店ID；本次关联仅针对当前门店。',
  applicabilityPoiHint: '以下为平台适用门店的 poiId；本次关联仅针对当前门店。',
  noApplicableShops: '平台返回的适用门店为空',
  awaitingPull: '待拉取更新',
  metadataUnavailable: '平台商品资料不完整，请重新拉取',
  unsupportedProduct: '当前商品类型不支持普通团购券核销',
  confirmProductUnlink: '确认解除“{shop}”中“{product}”的核销商品关联？平台商品资料和已受理核销记录会保留。',
  pullState: '拉取状态',
  pulledCount: '已获取规格数',
  failureReason: '失败原因',
  pullStarted: '提交时间',
  pullSubmitted: '拉取已提交，可在拉取记录查看进度',
  pullSelectionHint: '选择已绑定且授权可用的门店，后台将拉取各店的全部团购商品规格。每次最多100家。',
  backgroundPullHint: '关闭页面后任务继续执行。失败门店可单独重试，已有核销商品关联保留。',
  selectedPullShops: '已选择 {count} 家门店',
  retryPull: '重试',
  close: '关闭',
  startPull: '开始拉取',
  localSelectionRequired: '请选择核销商品规格，并填写1至10000的整数份数',
  localProductType: '核销商品类型',
  ticketProduct: '票务',
  coinProduct: '游戏币',
  chooseLocalProduct: '请选择核销商品',
  changeProduct: '更换商品',
  collapseProductList: '收起列表',
  chooseLocalSku: '请选择核销商品规格',
  saveProductLink: '保存关联',
  pullStates: {WAITING:'等待拉取',RUNNING:'拉取中',SUCCEEDED:'已完成',FAILED:'失败'},
  zhiJieShop: '门店',
  currentShop: '当前门店：{name}',
  shopCode: '门店编码',
  shopSearch: '输入门店名称、编码或ID',
  bindingStatus: '绑定状态',
  bindingStates: { UNBOUND: '未绑定', BOUND: '已绑定', UNAVAILABLE: '绑定不可用' },
  bindingUpdated: '绑定更新时间',
  unavailableHelp: '查看不可用原因',
  platformShopId: '平台门店ID',
  platformShopName: '平台门店名称',
  refreshList: '刷新列表',
  bindNow: '立即绑定',
  changeBinding: '更换绑定',
  removeBinding: '解除绑定',
  bindShopTitle: '绑定门店',
  bindBelow: '前往「门店绑定」',
  selectAuthorization: '选择授权账号',
  chooseAccount: '请选择授权账号',
  selectPlatformShop: '选择平台门店',
  enterShopName: '输入平台门店名称',
  enterShopId: '输入平台门店ID',
  select: '选择',
  query: '查询',
  reset: '重置',
  bind: '绑定',
  saveChange: '保存更换',
  pageNumber: '第 {page} 页',
  confirmShopRemove: '确认解除“{shop}”的绑定？其他门店的绑定不受影响，已受理的核销记录保留。',
  applicableShops: '适用门店 ID',
  platformSku: '平台规格',
  localShop: '门店',
  selectShop: '请先选择门店',
  platformShop: '平台门店',
  platformProduct: '平台商品',
  localProduct: '核销商品',
  localSku: '核销商品规格',
  quantity: '核销份数',
  account: '授权账号',
  addShop: '绑定平台门店',
  addProduct: '关联商品',
  edit: '修改',
  remove: '解绑',
  save: '保存绑定',
  cancel: '取消',
  refresh: '刷新',
  loadMore: '加载更多',
  searchProduct: '输入核销商品名称查询',
  next: '下一页',
  previous: '上一页',
  status: '可用情况',
  available: '当前配置可用',
  actions: '操作',
  unbound: '未查询到绑定',
  confirmRemove: '确认解除该绑定？已受理的核销记录保留原交付内容。',
  selectRequired: '请完整选择平台门店、核销商品规格和核销份数',
  loadFailed: '查询失败，请重试',
  saved: '绑定已保存',
  removed: '绑定已解除',
  readOnly: '平台商品只用于查询和本地对应；不会发布或修改平台商品。',
  shopUnique: '每个平台下，一家智界门店只绑定一个平台门店。美团单店授权只能绑定一家智界门店。',
  productUnique: '同一平台规格在本店只保留一份对应。',
  noAccount: '请先完成主账号授权',
  noPermission: '没有团购绑定查询权限',
  business: '业务',
  selectPlatform: '选择平台门店后查询商品',
  configNeeded: '请先绑定平台门店',
  all: '全部平台',
  history: {
    period: '核销时间',
    startTime: '开始时间',
    endTime: '结束时间',
    rangeSeparator: '至',
    platformAndProduct: '平台及商品',
    quantity: '数量',
    submittedCount: '核销 {count} 张',
    quantityPerCoupon: '每券发放 {count} 份',
    loadingDetail: '正在加载逐券结果',
    noCouponDetails: '暂无逐券明细，请刷新详情。',
    noMatches: '没有符合条件的核销记录，可调整筛选条件或重置后查询。',
    staleResults: '刷新失败，当前保留并显示上次成功查询的结果。',
    staleDetail: '详情刷新失败，当前保留并显示上次成功查询的详情。',
    summaryOnly: '当前仅显示列表摘要，请刷新详情以读取逐券结果。',
    provider: '平台',
    processStatus: '处理状态',
    processCounts: '处理进度',
    allProcessStatuses: '全部处理状态',
    processStatuses: {
      VERIFYING: '核销中',
      VERIFY_UNKNOWN: '待确认核销结果',
      FAILED: '核销失败',
      DELIVERY_PENDING: '待完成发放',
      MANUAL_PENDING: '待人工发币',
      COMPLETED: '已完成',
      CANCELLING: '撤销处理中',
      CANCELLED: '已撤销',
    },
    platformStatus: '平台核销状态',
    deliveryStatus: '商品发放状态',
    allPlatforms: '全部平台',
    allPlatformStatuses: '全部核销状态',
    allDeliveryStatuses: '全部发放状态',
    batchNo: '核销记录编号',
    platformProduct: '平台商品',
    localProduct: '核销商品',
    rightsPerCoupon: '核销份数',
    rightsPerCouponHint: '每核销一张平台券，对应发放的本地商品份数。',
    requestedVouchers: '核销券数',
    recipient: '顾客',
    shop: '门店',
    operator: '操作人',
    createTime: '核销时间',
    actions: '操作',
    viewDetail: '查看详情',
    detailTitle: '核销详情',
    copyLabel: '复制{label}',
    copySuccess: '{label}已复制',
    copyFailed: '复制失败，请手动复制',
    reloadLocal: '刷新详情',
    platformCounts: '平台核销结果',
    deliveryCounts: '商品发放情况',
    couponRecords: '券明细',
    couponRecordCount: '共 {count} 张券',
    couponId: '平台券编号',
    memberNo: '会员号',
    member: '会员',
    guest: '散客',
    failureReason: '失败原因',
    notIssued: '未发放',
    deliveryNoResult: '等待平台结果',
    close: '关闭',
    loadFailed: '核销记录查询失败，请重试',
    detailLoadFailed: '核销详情查询失败，请重试',
    platformStatuses: {
      PROCESSING: '处理中',
      SUCCEEDED: '核销成功',
      FAILED: '核销失败',
      UNKNOWN: '结果待确认',
      CANCELLING: '撤销中',
      CANCELLED: '已撤销',
      CANCEL_UNKNOWN: '撤销结果待确认',
    },
    deliveryStatuses: {
      PENDING: '待发放',
      DELIVERED: '已发放',
      MANUAL_PENDING: '待人工发币',
      MANUAL_DONE: '人工发币完成',
      REVOKED: '已收回',
    },
  },
},
};
